import HeroIV from "./HeroIV";
import compose from "recompose/compose";
import mapProps from "recompose/mapProps";
import defaultProps from "recompose/defaultProps";
import formatPrismicData from "../../hocs/formatPrismicData";
import { withModel } from "../../data-providers/model";
import { localiseUrl } from "src/common/utils/format-localised-url";

const enhance = compose(
  withModel,
  formatPrismicData,
  defaultProps({
    contentColor: "grey-dark",
    ctaColor: "grey-dark",
  }),
  mapProps((props) => ({
    ...props,
    ctaLink:
      !!props.ctaLink && localiseUrl(props.model.countryModel, props.ctaLink),
  }))
);

export default enhance(HeroIV);
